import { render, staticRenderFns } from "./BaseInputDateText.vue?vue&type=template&id=42b8db23&scoped=true&"
import script from "./BaseInputDateText.vue?vue&type=script&lang=js&"
export * from "./BaseInputDateText.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputDateText.vue?vue&type=style&index=0&id=42b8db23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8db23",
  null
  
)

export default component.exports